import { createSlice } from "@reduxjs/toolkit";
import { modalState } from "../../utils/constants";

const initialState = {
  activeModals: [],
  authModal: {
    prev: "",
    curr: "",
  },
  isClosing: false, // Флаг, указывающий, что модалка в процессе закрытия
  blackout: false,
  blackoutZIndex: 100,
};

export const modalSlice = createSlice({
  name: "modalSlice",
  initialState,
  reducers: {
    goToAuthPanel: (state, action) => {
      state.authModal.prev = state.authModal.curr;
      state.authModal.curr = action.payload;
      if (!state.activeModals.includes(modalState.AUTH)) {
        state.activeModals.unshift(modalState.AUTH);
      }
    },
    openModal: (state, action) => {
      if (!state.activeModals.includes(action.payload)) {
        state.activeModals.unshift(action.payload);
        if (!(action.payload === modalState.TOGGLE_STREAM)) {
          state.blackout = true;
          state.blackoutZIndex = 100 * state.activeModals.length;
        }
      }
    },
    closeModal: (state, action) => {
      if (action.payload) {
        const newActiveModals = [...state.activeModals];

        newActiveModals.splice(newActiveModals.indexOf(action.payload), 1);
        state.activeModals = newActiveModals;

        if (!newActiveModals.length) {
          state.blackout = false;
        }
      } else {
        state.blackout = false;
        state.authModal.curr = modalState.NONE;
        state.authModal.prev = modalState.NONE;
        state.activeModals = [];
      }
    },
    startClosing: (state) => {
      state.isClosing = true; // Устанавливаем флаг при начале закрытия
    },
    resetClosing: (state) => {
      state.isClosing = false; // Устанавливаем флаг при начале закрытия
    },
    enableBlackout: (state) => {
      state.blackout = true;
    },
    disableBlackout: (state) => {
      state.blackout = false;
    },
  },
});

export const selectIsOpen = (modal) => (state) =>
  state.modalSlice.activeModals.includes(modal);
export const selectIsLast = (modal) => (state) =>
  state.modalSlice.activeModals[0] === modal;
export const getZIndex = (state) => state.modalSlice.blackoutZIndex;

export const {
  goToAuthPanel,
  closeModal,
  openModal,
  startClosing,
  resetClosing,
  enableBlackout,
  disableBlackout,
} = modalSlice.actions;
export default modalSlice.reducer;
